'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInUpBig = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUpBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-up-big.js
// module id = 215
// module chunks = 54990529738226 257444579329143